import { render, staticRenderFns } from "./AlbumSongInfoItem.vue?vue&type=template&id=44485eda&scoped=true&"
import script from "./AlbumSongInfoItem.vue?vue&type=script&lang=js&"
export * from "./AlbumSongInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./AlbumSongInfoItem.vue?vue&type=style&index=0&id=44485eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44485eda",
  null
  
)

export default component.exports